import styled from "@emotion/styled";
import { Paper } from "../Paper/Paper";

export const DialogRoot = styled(Paper)`
  width: 100%;
  max-width: min(1200px, 95vw);
  min-width: min(350px, 100vw);
  max-height: 95vh;
  display: flex;
  flex-direction: column;
  //box-shadow: var(--shadowBase);
  //border: 1px solid var(--colorFill4);
  height: fit-content;
  //border-radius: var(--borderRadiusBase);
  overflow: hidden;
  //background-color: var(--colorFill2);
`
export const DialogHeader = styled.div`
  align-items: center;
  display: flex;
  padding: var(--sizeBase4) var(--sizeBase5);
  padding-right: 44px;
  //background-color: var(--colorBackground2);
  border-radius: var(--borderRadiusBase) var(--borderRadiusBase) 0 0;
  height: 44px;
 
`
export const DialogBody = styled.div`
  max-height: calc(100vh - 48px);
  padding: var(--sizeBase5) var(--sizeBase5);
  //background-color: var(--colorBackground2);

`
export const DialogActions = styled.div`
  padding: var(--sizeBase5);
  border-radius: 0 0 var(--borderRadiusBase) var(--borderRadiusBase);
  display: flex;
  justify-content: end;

  & > button + button,
  & > :not(style) ~ :not(style) {
    margin-left: var(--sizeBase5);
  }
`
export const DialogHeaderTitle = styled.div`
  font-size: 16px;
`
export const CloseIcon = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 44px;
  border: 1px solid transparent;
  border-top-right-radius: var(--borderRadiusBase);

  &:hover {
    background-color: var(--colorRed);

    & svg {
      color: var(--colorTextReverse);
    }
  }

  &:active {
    background-color: color-mix(in srgb, var(--colorRed), 30% transparent);

    & svg {
      color: var(--colorTextReverse);
    }
  }

  & svg {
    color: var(--colorText);
  }
`